import { useEffect } from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { RoutesPaths } from "../Router/constant";
import ContactForm from "../Components/Contact-form";

function PrivateSector() {
  const { t } = useTranslation();
  const expansionCards = t("pages.privateSector.expansion.cards", {
    returnObjects: true,
  });
  const capitalCards = t("pages.privateSector.capital.cards", {
    returnObjects: true,
  });
  const disciplineItems = t("pages.privateSector.disciplines.items", {
    returnObjects: true,
  });

  useEffect(() => {
    const elements = document.querySelectorAll(".reveal-on-scroll");

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const delay = entry.target.dataset.delay;
            if (delay) {
              entry.target.style.transitionDelay = `${delay}ms`;
            }

            entry.target.classList.add("show");
            obs.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.2,
        rootMargin: "0px 0px -50px 0px",
      }
    );

    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="private-sector-page">
      <section className="private-sector-hero">
        <div className="main-container">
          <div className="private-sector-hero__inner">
            <h1 className="m-0 private-sector-hero__title f-s-48 l-h-60 reveal-on-scroll fade-up" data-delay="100">
              {t("pages.privateSector.hero.title")}
            </h1>

            <p className="m-0 f-s-20 l-h-30 private-sector-hero__text reveal-on-scroll fade-up" data-delay="150">
              {t("pages.privateSector.hero.text")}
            </p>

            {/* <div
              className="private-sector-hero__chips reveal-on-scroll fade-up"
              data-delay="300"
              aria-label={t("pages.privateSector.hero.chipsLabel")}
            >
              {t("pages.privateSector.hero.chips", { returnObjects: true }).map((chip) => (
                <span className="private-sector-hero__chip" key={chip}>
                  {chip}
                </span>
              ))}
            </div> */}
          </div>
        </div>
      </section>

      <section className="private-sector-section">
        <div className="main-container">
          <div className="private-sector-heading">
            <h2 className="m-0 private-sector-heading__title f-s-48 l-h-60 reveal-on-scroll fade-left">
              {t("pages.privateSector.expansion.title")}
            </h2>

            <p className="m-0 f-s-20 l-h-30 reveal-on-scroll fade-right" data-delay="150">
              {t("pages.privateSector.expansion.text")}
            </p>
          </div>

          <div className="row g-5 align-items-center">
            <div className="col-md-6">
              <div className="private-sector-collage reveal-on-scroll fade-left" data-delay="200">
                <div className="private-sector-collage__primary">
                  <img src="/images/investment.png" alt="Business strategy workshop" />
                </div>
                <div className="private-sector-collage__secondary">
                  <img src="/images/expansion.png" alt="Team collaboration" />
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="private-sector-card-list">
                {expansionCards.map((item, index) => (
                  <article
                    className="private-sector-card reveal-on-scroll fade-right"
                    data-delay={`${index * 150}`}
                    key={item.title}
                  >
                    <span className="private-sector-card__eyebrow">{item.eyebrow}</span>
                    <h3 className="m-0 private-sector-card__title f-s-20 l-h-30">{item.title}</h3>
                    <p className="m-0 f-s-16 l-h-24 private-sector-card__description">
                      {item.description}
                    </p>
                    <div className="private-sector-tags">
                      {item.tags.map((tag) => (
                        <span className="private-sector-tag" key={tag}>
                          {tag}
                        </span>
                      ))}
                    </div>
                  </article>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="private-sector-section private-sector-section--emerald">
        <div className="main-container">
          <div className="private-sector-heading private-sector-heading--light">
            <h2 className="m-0 private-sector-heading__title f-s-48 l-h-60 reveal-on-scroll fade-left">
              {t("pages.privateSector.capital.title")}
            </h2>
            <p className="m-0 f-s-20 l-h-30 text-white reveal-on-scroll fade-right" data-delay="150">
              {t("pages.privateSector.capital.text")}
            </p>
          </div>

          <div className="row g-5 align-items-center">
            <div className="col-md-6 order-2 order-md-1">
              <div className="private-sector-card-list">
                {capitalCards.map((item, index) => (
                  <article className="private-sector-card reveal-on-scroll fade-left" key={item.title} data-delay={`${index * 150}`}>
                    <span className="private-sector-card__eyebrow">{item.eyebrow}</span>
                    <h3 className="m-0 private-sector-card__title f-s-20 l-h-30">{item.title}</h3>
                    <p className="m-0 f-s-16 l-h-24 private-sector-card__description">
                      {item.description}
                    </p>
                    <div className="private-sector-tags">
                      {item.tags.map((tag) => (
                        <span className="private-sector-tag" key={tag}>
                          {tag}
                        </span>
                      ))}
                    </div>
                  </article>
                ))}
              </div>
            </div>

            <div className="col-lg-6 order-1 order-lg-2">
              <div className="private-sector-collage private-sector-collage--right reveal-on-scroll fade-right" data-delay="200">
                <div className="private-sector-collage__primary">
                  <img src="/images/expansion.png" alt="Executive planning session" />
                </div>
                <div className="private-sector-collage__secondary">
                  <img src="/images/investment.png" alt="Private capital team" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
       <div className="section section-who-we-are privatesection">
            <div className="main-container">
              <div className="row g-0 align-items-stretch justify-content-start">
                <div className="col-md-6 d-flex">
                  <div className="who-content">
                    <h2
                      className="m-0 f-w-600 f-s-48 l-h-60 c-s-w reveal-on-scroll fade-right"
                      data-delay="300"
                    >
                      {t("pages.privateSector.capital.title")}
                    </h2>

                    <p
                      className="m-0 f-s-20 l-h-30 c-s-w who-subtext reveal-on-scroll fade-right"
                      data-delay="400"
                    >
                      {t("pages.privateSector.capital.text")}
                    </p>

                    {capitalCards.map((item, index) => (
                      <div
                        className={`who-card private-sector-capital-card reveal-on-scroll ${index === 0 ? "fade-right" : "mt-3 fade-left"}`}
                        key={item.title}
                        data-delay={`${500 + index * 100}`}
                      >
                        <div className="card-top">
                          <div className="icon-box">
                            <img
                              src={index === 0 ? "/images/mergers-acquisitions-icon.svg" : "/images/capital-restructuring-icon.svg"}
                              alt=""
                              className="private-sector-capital-card__icon"
                              width="48"
                              height="48"
                            />
                          </div>
                        </div>
                        <h6 className="m-0 f-w-600 f-s-24 l-h-32 c-s-w">{item.title}</h6>
                        <p className="m-0 f-s-16 l-h-24 c-s-w">{item.description}</p>
                        <div className="private-sector-tags">
                          {item.tags.map((tag) => (
                            <span className="private-sector-tag" key={tag}>{tag}</span>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

      <section className="private-sector-section">
        <div className="main-container">
          <div className="private-sector-heading">
            <h2 className="m-0 private-sector-heading__title f-s-48 l-h-60 reveal-on-scroll fade-left">
              {t("pages.privateSector.disciplines.title")}
            </h2>
            <p className="m-0 f-s-20 l-h-30 reveal-on-scroll fade-right" data-delay="150">
              {t("pages.privateSector.disciplines.text")}
            </p>
          </div>

          <div className="private-sector-discipline-grid">
            {disciplineItems.map((item) => (
              <article className="private-sector-discipline reveal-on-scroll fade-up" key={item.number} data-delay={`${item.number * 150}`}>
                <span className="private-sector-discipline__number">{item.number}</span>
                <div className="private-sector-discipline__icon">
                  <img
                    src={
                      item.number === "01"
                        ? "/images/strategy-icon.svg"
                        : item.number === "02"
                          ? "/images/financial-icon.svg"
                          : item.number === "03"
                            ? "/images/partners-icon.svg"
                            : "/images/execution-icon.svg"
                    }
                    alt=""
                  />
                </div>
                <h3 className="m-0 private-sector-discipline__title f-s-20 l-h-30">{item.title}</h3>
                <p className="m-0 f-s-16 l-h-24 private-sector-discipline__text">{item.description}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="private-sector-section private-sector-section--contact">
        <div className="main-container">
          <div className="private-sector-heading">
            <h2 className="m-0 private-sector-heading__title f-s-48 l-h-60 reveal-on-scroll fade-left">
              {t("pages.privateSector.contact.title")}
            </h2>
            <p className="m-0 f-s-20 l-h-30 reveal-on-scroll fade-right" data-delay="150">
              {t("pages.privateSector.contact.text")}
            </p>
          </div>

          <div className="row g-5 align-items-center">
            <div className="col-md-6 privatesector-img">
              <div className="private-sector-contact-media privatesector-img reveal-on-scroll fade-left" data-delay="200">
                <img src="/images/Transform.png" alt="Contact the PROVEST team" />
              </div>
            </div>

            <div className="col-md-6">
              <ContactForm
                variant="private"
                website="provestCapital"
                formClassName="reveal-on-scroll fade-right"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="section section-stratagic mt-0">
        <div className="main-container">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-md-9 text-center px-3">
              <h2 className="m-0 f-w-600 f-s-48 l-h-60 c-s about-cta__title reveal-on-scroll fade-up">
                {t("pages.privateSector.cta.title")}
              </h2>
              <p className="m-0 f-s-20 l-h-30 c-s about-cta__text reveal-on-scroll fade-up" data-delay="150">
                {t("pages.privateSector.cta.text")}
              </p>
              <NavLink
                className="contact-btn d-flex align-items-center f-w-600 f-s-14 l-h-100 mx-auto"
                to={RoutesPaths.CONTACT}
              >
                <span className="btn-text">{t("common.cta.contact")}</span>
                <span className="arrow-circle">
                  <img src="/images/right-angle-arrow.png" alt="icon" />
                </span>
              </NavLink>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default PrivateSector;
